import { useState } from 'react';
import axios from 'axios';

const useDeleteOrder = () => {
  const [loading, setLoading] = useState(false);

  const deleteOrder = async (orderId) => {
    if (!orderId) return;

    setLoading(true);
    try {
      const response = await axios.post(
        `https://bulkify.in/api/vendor/delete-order.php?formtype=deleteOrder&oid=${orderId}`
      );

      if (response.data.Massage === "Successfully Delete") {
 
        window.location.reload(); 
      }
    } catch (error) {
      console.error("Error deleting order:", error);
      alert("Error deleting order. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return { deleteOrder, loading };
};

export default useDeleteOrder;
